
// JQuery Start
jQuery(document).ready(function ($) {

    var body = $('body'),
        header = $('header'),
        bodyHtml = $('body', 'html'),
        nav = $('nav#main-nav'),
        logo = $('div.logo a'),
        mainNavLinks = $('#main-nav ul li a'),
        coverBtn = $('#top-cover a');

    //
    // Page transition animation
    //

    var newLocation;

    function newpage() {
        window.location = newLocation;
    }
    mainNavLinks.add(logo).click(function () {
        event.preventDefault();
        newLocation = this.href;
        body.animate({
            opacity: 0
        }, 350, newpage);
    }

    //
    // Modalbox
    //

    );var modalBox = $('div.inner-modal'),
        modalOverlay = $('div.modal-overlay'),
        modalContent = $('div.modal-content');

    // toggle modal
    function toggleModal() {
        $('div.modal-content').addClass('no-close');
        modalOverlay.show();
        setTimeout(function () {
            modalOverlay.addClass('disp');
            setTimeout(function () {
                modalBox.addClass('disp');
            }, 100);
        }, 100);
    }

    // hide modal
    function removeModal(e) {
        // if clicked inside modal box, ignore it
        if ($(e.target).closest('.no-close')[0]) {
            return false;
        } else {
            modalOverlay.removeClass('disp');
            modalBox.removeClass('disp');
            setTimeout(function () {
                modalContent.find('iframe').hide();
                modalOverlay.hide();
            }, 300);
            modalContent.find('iframe').attr('src', '');
        }
    }

    // bind button to toggle modal
    $('.modal-btn').on('click', function (e) {
        e.preventDefault();
        toggleModal();
    });

    $('.video').on('click', function (e) {
        e.preventDefault();
        toggleModal();
        var videoToAppend = 'https://www.youtube.com/embed/' + $(this).find('p.hidden-link').text();
        modalContent.find('iframe').show();
        modalContent.find('iframe').attr('src', videoToAppend);
    });

    // bind overlay to hide modal
    modalOverlay.on('click', function (e) {
        removeModal(e);
    });

    // hide modal on esc keyup
    $(document).keyup(function (e) {
        if (e.which === 27) {
            removeModal(e);
        }
    });

    //
    // Show navbar for submenu
    //
    $('nav#main-nav >div >div >ul >li').hover(function () {
        var el = $(this);
        var subMenu = el.find('.sub-menu');

        if (subMenu.length > 0) {
            el.find('.sub-menu').addClass('show-me');
            $('.submenu-container').addClass('show-me');
        }
    }, function () {
        var el = $(this);

        el.find('.sub-menu').removeClass('show-me');
        $('.submenu-container').removeClass('show-me');
    });

    //
    // Responsive Nav
    //

    var pullMenu = $('.pull_menu'),
        line1 = $('.line-1'),
        line2 = $('.line-2'),
        line3 = $('.line-3');

    pullMenu.click(function () {
        nav.toggleClass('pull_menu_in_out');
        line1.toggleClass('line-1-animate');
        line2.toggleClass('line-2-remove');
        line3.toggleClass('line-3-animate');
        body.toggleClass('no-scroll');
    });

    //
    // Forespørgsel dynamisk navn
    //

    var masterHeader = $('#master-header').text();
    $('.request-name').val(masterHeader);

    //
    //  Text-Image Widget -> Swap on responsive
    //

    function swapImages() {

        if ($('.col-1-2').css('float') !== 'left') {
            $('.swap').each(function () {
                $(this).insertAfter($(this).next('.col-1-2'));
            });
        }

        if ($('.col-1-2').css('float') === 'left') {
            $('.swap').each(function () {
                $(this).insertBefore($(this).prev('.col-1-2'));
            });
        }
    }

    $(window).resize(function () {
        swapImages();
    });

    swapImages();

    //
    // Buy book form
    //

    // Add another delivery adress
    var anotherAdress = $('span.another-adress input[type="checkbox"]'),
        levering = $('div.levering');

    // If checked then add class to display box below
    if ($('span.another-adress input[type="checkbox"]:checked').length > 0) {
        levering.addClass('show');
    } else {
        levering.removeClass('show');
    }

    // on click check of already checked else add class to display box below
    anotherAdress.on('click', function () {
        if ($('span.another-adress input[type="checkbox"]:checked').length > 0) {
            levering.addClass('show');
        } else {
            levering.removeClass('show');
        }
    });

    // Change dummy text on radio click
    var paymentMethod = $('div.payment-method'),
        bankTrans = $('p.first'),
        mobilePay = $('p.second'),
        faktura = $('p.third');

    // Radio on change - check which value is chosen
    $('div.payment-method input[type="radio"]').on('change', function () {
        if (paymentMethod.find($('input[type="radio"]:checked')).val() === 'MobilePay') {
            paymentMethod.find('p.show').removeClass('show');
            mobilePay.addClass('show');
        } else if (paymentMethod.find($('input[type="radio"]:checked')).val() === 'Faktura') {
            paymentMethod.find('p.show').removeClass('show');
            faktura.addClass('show');
        } else {
            paymentMethod.find('p.show').removeClass('show');
            bankTrans.addClass('show');
        }
    });

    // Smooth Scroll
    $('body').on('click', 'a', function() {
        // Only same-page anchors: $(href) throws on URLs such as /boghandel/?add-to-cart=178
        const href = $.attr(this, 'href') || ''
        let top1 = /^#[\w-]+$/.test(href) ? $(href)?.offset()?.top : undefined
        if (top1) {
            $('html, body').animate({
                scrollTop: top1 - 120
            }, 500);
            return false;
        }
    });

    // Show searchbar on click
    $('.search-now .icon').on('click', function (e) {
        var searchNow = $(e.target);
        var searchInput = $('.search-bar-desktop').find('input');
        if (!searchNow.is('.search-now')) {
            searchNow = searchNow.closest('.search-now');
        }

        var icon = $(e.target);
        if (!icon.is('.icon')) {
            icon = icon.closest('.icon');
        }

        if (!(icon.length > 0 && searchNow.is('.active')) && searchNow.length > 0) {
            searchNow.addClass('active');
            searchNow.find('.search-bar-desktop').addClass('display-search');

            setTimeout(function () {
                searchInput.focus();
                searchInput.val(searchInput.val());
            }, 50);
        } else {
            searchNow = $('.search-now');
            searchNow.removeClass('active');
            searchNow.find('.search-bar-desktop').removeClass('display-search');
        }
    });

    (function ($) {
        jQuery(document).ready(function () {

            var container = $('.share-button');
            var wrapper = $('.share-button-wrapper');

            $(document).on('click', '.share-button-wrapper a', {}, function popUp(e) {
                var self = $(this);

                if (self.attr('href').indexOf('mailto:') === -1) {
                    popupCenter(self.attr('href'), self.find('.rrssb-text').html(), 580, 470);
                    e.preventDefault();
                }
            });

            var popupCenter = function popupCenter(url, title, w, h) {
                // Fixes dual-screen position                         Most browsers      Firefox
                var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
                var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

                var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
                var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

                var left = ((width / 2) - (w / 2)) + dualScreenLeft;
                var top = ((height / 3) - (h / 3)) + dualScreenTop;

                var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

                // Puts focus on the newWindow
                if (newWindow && newWindow.focus) {
                    newWindow.focus();
                }
            };
        });
    })(jQuery);


    // Slider widget
    var mttCoverSlider = document.querySelector('.mtt-cover-slider');

    if (mttCoverSlider) {
        var sliderDelayValue = mttCoverSlider.getAttribute('data-slider-delay');
        var sliderDelay = sliderDelayValue ? parseInt(sliderDelayValue) : 3000;

        var mySwiper = new Swiper('.mtt-cover-slider .swiper-container', {
            loop: true,
            threshold: 10,
            autoplay: {
                delay: sliderDelay
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            on: {
                slideChange: function(swiper) {
                    var videoElement = swiper.slides[swiper.activeIndex].querySelector('video');
                    var videoElementPrev = swiper.slides[swiper.previousIndex].querySelector('video');

                    if(videoElementPrev) {
                        videoElementPrev.pause();
                    }

                    if(videoElement) {
                        videoElement.play();
                    }
                }
            }
        });
    }

    // Articles accordion

    var articlesTitles = document.querySelectorAll('.articles-archive__cat-title');

    if (articlesTitles.length) {
        addArticlesAccordions();
    }

    function addArticlesAccordions() {
        for (let i = 0; i < articlesTitles.length; i++) {
            const title = articlesTitles[i];

            title.addEventListener('click', function() {
                title.classList.toggle('rotate');
                title.nextElementSibling.classList.toggle('hide');
            });
        }
    }

    /**
     * Program overview
     */
    const programOverviewTriggers = document.querySelectorAll('.program-overview__title-wrap')
    const accordionTriggers = document.querySelectorAll('.mtt-accordion__trigger')
 
    function toggleProgramSections () {
        for (let index = 0; index < programOverviewTriggers.length; index++) {
            const trigger = programOverviewTriggers[index]
            const triggerId = trigger.getAttribute('data-trigger-id')
 
            trigger.addEventListener('click', function (e) {
                const activeSection = document.querySelector('.program-overview__section--active')
                const activeTitle = document.querySelector('.program-overview__title-wrap--active')
                const newSection = document.querySelector(`[data-section-id="${triggerId}"]`)

                activeTitle.classList.remove('program-overview__title-wrap--active')
                activeSection.classList.remove('program-overview__section--active')
                trigger.classList.add('program-overview__title-wrap--active')
                newSection.classList.add('program-overview__section--active')
            })
        }
    }

    function toggleAccordion () {
        for (let index = 0; index < accordionTriggers.length; index++) {
            const trigger = accordionTriggers[index];

            trigger.addEventListener('click', function (e) {
                const accordion = this.parentNode
                accordion.classList.toggle('mtt-accordion--active')
            });
        }
    }
 
    if (programOverviewTriggers.length) {
        toggleProgramSections()
    }

    if (accordionTriggers.length) {
        toggleAccordion()
    }

    if ('objectFit' in document.documentElement.style === false) {
        var container = document.getElementsByClassName('object-fit');

        for (var i = 0; i < container.length; i++) {
            var imageSource = container[i].querySelector('img').src;
            var imageSourceFull = container[i].querySelector('img').getAttribute('full');
            imageSource = (imageSourceFull !== '' && imageSourceFull !== null) ? imageSourceFull : imageSource;
            container[i].querySelector('img').style.display = 'none';
            container[i].style.backgroundSize = 'cover';
            container[i].style.backgroundImage = 'url(' + imageSource + ')';
            container[i].style.backgroundPosition = 'center center';
            container[i].style.backgroundRepeat = 'no-repeat';
        }
    }

    /**
     * Open morning catch popup with an URL parameter
     */
    const observerCallback = function () {
        const morningCatchButton = document.querySelector('.mt-trigger-button')

        if (morningCatchButton) {
            morningCatchButton.click()
            observer.disconnect()
        }
    }

    const observer = new MutationObserver(observerCallback);
    const observerConfig = { attributes: false, childList: true, subtree: false };

    if (window.location.search === '?nyhedsbrev') {
        observer.observe(document.body, observerConfig);  
    }

    /**
     * Faggrupper tabbed content
     */
    $(document).on('click', '[data-tab-index]', function (e) {
        e.preventDefault();
        const tabIndex = $(this).attr('data-tab-index');
        const tabGroup = $(this).attr('data-tab-group');

        const activeTab = $(`.active[data-tab-index][data-tab-group="${tabGroup}"]`)
        const activeContent = $(`.active[data-tab-content][data-tab-group="${tabGroup}"]`)
        const newTab = $(`[data-tab-index="${tabIndex}"][data-tab-group="${tabGroup}"]`)
        const newContent = $(`[data-tab-content="${tabIndex}"][data-tab-group="${tabGroup}"]`)
        const urlParam = newTab.attr('data-tab-url')
        activeTab.removeClass('active')
        activeContent.removeClass('active')
        newTab.addClass('active')
        newContent.addClass('active')

        // Add url parameters
        if (newTab.attr('data-tab-group') === 'main') {
            let baseUrl = window.location.href.split('?')[0].split('#')[0]
            window.history.pushState('', '', baseUrl + '?tab=' + urlParam)
        } else {
            let baseUrl = window.location.href.split('&')[0].split('#')[0]
            window.history.pushState('', '', baseUrl + '&subtab=' + urlParam)
        }
    });

    // Link boxes widget
    var linkBoxes = document.querySelector('.link-boxes');

    if (linkBoxes) {
        var mySwiper = new Swiper('.link-boxes .swiper-container', {
            loop: false,
            threshold: 10,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            slidesPerView: 1.15,
            spaceBetween: 20,
            breakpoints: {
                401: {
                    slidesPerView: 1.25
                },
                501: {
                    slidesPerView: 1.5
                },
                581: {
                    slidesPerView: 2.25
                },
                761: {
                    slidesPerView: 2.5
                },
                961: {
                    slidesPerView: 3.5
                },
                1181: {
                    slidesPerView: 4.15
                }
            }
        });
    }

    // Company Members widget
    var companyMembersWidgets = document.querySelectorAll('.mtt-company-members')
    if (companyMembersWidgets.length > 0) {
        companyMembersWidgets.forEach(function (companyMembersWidget) {
            var loadMoreButton = companyMembersWidget.querySelector('.mtt-company-members__load-more-button')
            if (loadMoreButton) {
                loadMoreButton.addEventListener('click', function (){
                    companyMembersWidget.classList.add('mtt-company-members--show-all')

                    loadMoreButton.parentElement.remove()
                })
            }
        })
    }

    // Company Members Slider
    var companyMembersSliders = document.querySelectorAll('.mtt-company-members-slider');
    if (companyMembersSliders.length > 0) {
        companyMembersSliders.forEach(function (companyMembersSlider) {
          const SWIPER_ELEMENT = companyMembersSlider.querySelector('.swiper')
          const SWIPER_WRAPPER = companyMembersSlider.querySelector('.swiper-wrapper')
          const SWIPER_SLIDES = companyMembersSlider.querySelectorAll('.swiper-slide')

          if (!SWIPER_ELEMENT) {
            return
          }

          const shouldSlide = companyMembersSlider.classList.contains('mtt-company-members-slider--should-slide')
          const totalSlides = SWIPER_SLIDES.length

          const swiperOptions = {
            watchSlidesProgress: true,
            loop: true,
            allowTouchMove: false,
            spaceBetween: 32,
            slidesPerView: 2,
            breakpoints: {
              501: {
                slidesPerView: 3,
              },
              801: {
                slidesPerView: 4,
              },
              1537: {
                slidesPerView: 5,
              },
            },
          }

          if (shouldSlide) {
            // Ensure there are at least 10 slides for smooth sliding effect
            if (totalSlides < 10) {
              const slidesToDuplicate = 10 - totalSlides

              // Duplicate slides if necessary
              for (let i = 0; i < slidesToDuplicate; i++) {
                if (SWIPER_WRAPPER.childElementCount >= 10) {
                  break // Break out of the loop if the total slides reach or exceed 10
                }

                SWIPER_SLIDES.forEach((slide) => {
                  const clonedSlide = slide.cloneNode(true)
                  SWIPER_WRAPPER.appendChild(clonedSlide)
                })
              }
            }

            // Conditionally add autoplay options if shouldSlide is true
            swiperOptions.autoplay = {
              delay: 10, // Set delay to 10 for immediate autoplay. It must be greater than 0, in order for autoplay pause to work
              disableOnInteraction: false,
            }
            swiperOptions.speed = 6000
          }

          // Initialize Swiper
          var swiper = new Swiper(SWIPER_ELEMENT, swiperOptions)

        })
    }

});
